import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const EarningsBox = () => {
	const block = document.querySelectorAll(".earnings-box");
	if (!block) {
		return;
	}
	block.forEach((element) => {
		gsap.registerPlugin(ScrollTrigger);
		const bg = element.querySelector(".earnings-box__bg-fill");
		const text = element.querySelector(".earnings-box__text");
		const listItems = element.querySelectorAll(".earnings-box__list-item");

		const TLInfoTiles = gsap.timeline({
			scrollTrigger: {
				trigger: element,
				start: 'top 80%',
				end: `+=${window.innerHeight * 0.6}`,
				scrub: true
			}
		});
		TLInfoTiles.fromTo(bg, { y: 100, scale: 0.8, borderRadius: 20 }, { y: 0, scale: 1, borderRadius: 40, duration: 2 }, 0);
		TLInfoTiles.fromTo(text, { y: 100, opacity: 0 }, { y: 0, opacity: 1, duration: 2 }, 1);
		TLInfoTiles.to(listItems, { y: "0%", opacity: 1, stagger: { each: 0.4 } }, 2);
	});
};

export default EarningsBox;
